import common from "../../utill/Common";

class AuthService {
  sendOtp = async (emp_id, password, lat, long) => {
    const url = common.baseUrl + "admin/login/send_otp";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        emp_id,
        password,
        lat,
        long,
        login_via: "WEB",
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  verifyOtp = async (token, otp) => {
    const url = common.baseUrl + "admin/login/verify_otp";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        otp,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  forgotPassword = async (mobile, pan_number) => {
    const url = common.baseUrl + "admin/forgot_password/send_otp";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile,
        pan_number,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  forgotPasswordOtpVerify = async (token, otp, password) => {
    const url = common.baseUrl + "admin/forgot_password/verify_otp";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        otp: otp,
        token: token,
        new_password: password,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  isLoggedIn = () => {
    const token = localStorage.getItem("admin_access_token");
    if (token) {
      return true;
    } else {
      return false;
    }
  };

  getAccessToken = () => {
    const logged_in_on = localStorage.getItem("admin_timestamp");
    const token = localStorage.getItem("admin_access_token");

    if (logged_in_on === null || token === null) {
      //  localStorage.clear();
    }

    return token;
  };

  getUserID = () => {
    const user = JSON.parse(localStorage.getItem("admin"));

    if (!user) {
      return;
    }

    return user.user_id;
  };

  getName = () => {
    const user = JSON.parse(localStorage.getItem("admin"));

    if (!user) {
      return;
    }

    return user.name;
  };

  getUserType = () => {
    const user = JSON.parse(localStorage.getItem("admin"));

    if (!user) {
      return;
    }

    return user.employee_type;
  };

  getNavMenus = () => {
    const user = JSON.parse(localStorage.getItem("admin"));

    if (!user) {
      return;
    }

    return user.nav_menus;
  };

  logout = () => {
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin");
    localStorage.removeItem("admin_timestamp");
    return true;
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService();
